// Copyright (c) 2017 Deere & Company

import './special-allowance-claim-status-report.scss';
import {
    FormattedMessage,
    injectIntl,
    intlShape
} from 'react-intl';
import React, {
    Component,
    PropTypes
} from 'react';
import Criteria from '../state/criteria';
import DealerHierarchyTerritory from '@deere/cps-it.warranty-model-factory/lib/dealer-hierarchy-territory';
import FavoriteIcon from '../../../shared/components/favorites/favorite-icon';
import NumberOfRecordsFound from '../../../shared/components/number-of-records-found/index';
import ReportGrid from '../../shared/components/report-grid';
import ReportHeader from '../../shared/components/report-header';
import ReportHiddenColumns from '../../shared/components/report-columns';
import ReportLayout from '@deere/cps-it.warranty-model-factory/lib/report-layout';
import ShowNoResultsFound from '../../shared/components/show-no-results-found/show-no-results-found';
import SpecialAllowanceClaimStatus from '@deere/cps-it.warranty-model-factory/lib/special-allowance-claim-status';
import SpecialAllowanceClaimStatusReportCriteria from './special-allowance-claim-status-report-criteria';
import WarrantyAgGridDatePicker from '../../shared/components/ag-grid-date-picker';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import {exportToCSV} from '../../../reports/shared/services/export-to-csv';
import {getAgGridLocaleText} from '../../../shared/utils/ag-grid-locale-text';
import {getDefaultReportLayout} from '../../shared/services/report-variant';
import {getSpecialAllowanceClaimStatusColumnDefinitions} from '../report-services/column-definitions';
import {scrollToAndResizeReport} from '../../shared/services/scroll-window';

function handleCreateSpecialAllowanceClaimStatusReport() {

    this.actions.toggleReportIsScrollable();
    if (this.pathName === '/tabm/special-allowance-claim-status') {

        this.actions.createSpecialAllowanceClaimStatusReport(true);

    } else {

        this.actions.createSpecialAllowanceClaimStatusReport(false);

    }

}

function handleOriginalSubmissionDateSelect(originalSubmissionDate) {

    this.actions.selectOriginalSubmissionDate(originalSubmissionDate);

}

function handleTerritorySelect(territory, isSelected) {

    const territoryWithoutLabel = Object.freeze({
        leadAccounts: territory.leadAccounts,
        territory: territory.territory
    });

    this.actions.selectSpecialAllowanceClaimStatusTerritory(isSelected, territoryWithoutLabel);

}

function handleExportToCsv() {

    const fileName = 'special-allowance-claim-status';

    return exportToCSV(fileName, this.gridApi);

}

function handleSelectAllTerritories() {

    this.actions.selectAllTerritories(this.territories);

}

function handleGridApiDefinition(params) {

    let defaultColumnState,
        defaultSortModel;

    this.actions.createAgGridApi(params.api, params.columnApi);

    if (this.selectedLayout && this.selectedLayout.name && !this.isInitialLoad) {

        const defaultLayout = this.layouts.find(layout => !layout.name);

        defaultColumnState = defaultLayout.columnState;
        defaultSortModel = defaultLayout.sortModel;

    } else {

        defaultColumnState = params.columnApi.getColumnState();
        defaultSortModel = params.api.getSortModel();

        this.actions.updateReportProperty('isInitialLoad', false);

    }

    this.actions.updateDefaultLayout(defaultColumnState, defaultSortModel);

    if (this.selectedLayout && this.selectedLayout.name) {

        params.columnApi.setColumnState(this.selectedLayout.columnState);
        params.api.setSortModel(this.selectedLayout.sortModel);
        params.api.setFilterModel(this.selectedLayout.filterModel);

    } else {

        const defaultLayout = getDefaultReportLayout(defaultColumnState, defaultSortModel);

        this.actions.updateReportProperty('selectedLayout', defaultLayout);

    }

}

function onColumnRemoved(columnEvent) {

    if (!columnEvent.visible) {

        this.actions.hideReportColumn(this.columnApi.getColumnState());

    }

}

function handleCriteriaReset() {

    this.actions.resetSpecialAllowanceClaimStatusReport();
    this.actions.updateShowNoResultsFound(false);

}

class SpecialAllowanceClaimStatusReport extends Component {

    componentWillMount() {

        if (this.props.pathName === 'tabm/special-allowance-claim-status' || this.props.pathName === '/tabm/special-allowance-claim-status') {

            this.props.actions.readTerritoriesTabm(this.props.userId, true);

        } else {

            this.props.actions.readTerritories(this.props.userId);

        }
        this.props.actions.getReportLayouts('special-allowance-claim-status');

    }

    componentDidUpdate(prevProps) {

        if (this.props.reportIsScrollable && this.props.report.length) {

            this.props.actions.resetReportIsScrollable();

            scrollToAndResizeReport();

        }

        const isFirstRun = !prevProps.report.length && !prevProps.showNoResultsFound;
        const layoutWasChanged = this.props.selectedLayout !== prevProps.selectedLayout;
        const readyToApplyLayout = this.props.selectedLayout && Object.keys(this.props.columnApi).length && this.props.isDefaultColumnStateAvailable;

        if ((isFirstRun || layoutWasChanged) && readyToApplyLayout) {

            this.props.columnApi.setColumnState(this.props.selectedLayout.columnState);
            this.props.gridApi.setSortModel(this.props.selectedLayout.sortModel);
            this.props.gridApi.setFilterModel(this.props.selectedLayout.filterModel);

        }

    }

    componentWillUnmount() {

        this.props.actions.resetSpecialAllowanceClaimStatusReport();
        this.props.actions.resetReportVariant();

    }

    render() {

        const canExportToExcel = this.props.report.length > 0;

        const canRunReport = this.props.criteria.selectedTerritories.length > 0;

        const gridOptions = {
            dateComponentFramework: WarrantyAgGridDatePicker
        };

        return (
            <section className='special-allowance-claim-status'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                {this.props.pathName === '/tabm/special-allowance-claim-status' ?
                    <h2 className='special-allowance-claim-status-title'>
                        <FormattedMessage id='SPECIAL_ALLOWANCE_CLAIM_STATUS_TABM'/>
                        <FavoriteIcon
                            id='SPECIAL_ALLOWANCE_CLAIM_STATUS_TABM'
                            route={this.props.pathName}
                        />
                    </h2> :
                    <h2 className='special-allowance-claim-status-title'>
                        <FormattedMessage id='SPECIAL_ALLOWANCE_CLAIM_STATUS'/>
                        <FavoriteIcon
                            id='SPECIAL_ALLOWANCE_CLAIM_STATUS'
                            route={this.props.pathName}
                        />
                    </h2>
                }
                <SpecialAllowanceClaimStatusReportCriteria
                    allowedTerritories={this.props.territories}
                    canExport={canExportToExcel}
                    canRunReport={canRunReport}
                    criteria={this.props.criteria}
                    handleCriteriaReset={this.props::handleCriteriaReset}
                    handleOriginalSubmissionDateSelect={this.props::handleOriginalSubmissionDateSelect}
                    handleSelectAllTerritories={this.props::handleSelectAllTerritories}
                    handleTerritorySelect={this.props::handleTerritorySelect}
                    onCreateSpecialAllowanceClaimStatusReport={this.props::handleCreateSpecialAllowanceClaimStatusReport}
                    onExportToCsv={this.props::handleExportToCsv}
                />
                {this.props.report.length ?
                    <div>
                        <NumberOfRecordsFound count={this.props.report.length}/>
                        <section className='report'>
                            {this.props.isReportColumnsVisible && <ReportHiddenColumns/>}
                            <ReportHeader
                                columnApi={this.props.columnApi}
                                gridApi={this.props.gridApi}
                                reportName='special-allowance-claim-status'
                            />
                            <ReportGrid
                                columnDefs={getSpecialAllowanceClaimStatusColumnDefinitions()}
                                gridOptions={gridOptions}
                                localeText={getAgGridLocaleText()}
                                onColumnVisible={this.props::onColumnRemoved}
                                onGridReady={this.props::handleGridApiDefinition}
                                rowData={this.props.report}
                            />
                        </section>
                    </div> :
                    <ShowNoResultsFound showNoResultsFound={this.props.showNoResultsFound}/>
                }
            </section>
        );

    }

}

SpecialAllowanceClaimStatusReport.displayName = 'SpecialAllowanceClaimStatusReport';
SpecialAllowanceClaimStatusReport.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    columnApi: PropTypes.object.isRequired,
    criteria: PropTypes.instanceOf(Criteria).isRequired,
    gridApi: PropTypes.object.isRequired,
    intl: intlShape.isRequired,
    isDefaultColumnStateAvailable: PropTypes.bool.isRequired,
    isInitialLoad: PropTypes.bool.isRequired,
    isReportColumnsVisible: PropTypes.bool.isRequired,
    layouts: PropTypes.arrayOf(PropTypes.instanceOf(ReportLayout)).isRequired,
    pathName: PropTypes.string.isRequired,
    report: PropTypes.arrayOf(PropTypes.instanceOf(SpecialAllowanceClaimStatus)),
    reportIsScrollable: PropTypes.bool.isRequired,
    selectedLayout: PropTypes.instanceOf(ReportLayout),
    showNoResultsFound: PropTypes.bool.isRequired,
    territories: PropTypes.arrayOf(PropTypes.instanceOf(DealerHierarchyTerritory)).isRequired,
    userId: PropTypes.string.isRequired
};

export default injectIntl(SpecialAllowanceClaimStatusReport);



// WEBPACK FOOTER //
// ./src/reports/special-allowance-claim-status/components/special-allowance-claim-status-report.js